var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeroJobseeker = function SvgHeroJobseeker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 900,
    height: 600
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#42a5f5",
    d: "M0 0h900v600H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#009ad7",
    d: "m0 418 129 39 128-14 129-73 128 73 129 20 128 3 129-44v179H0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#a3cbeb",
    d: "m0 423 129 19 128 72 129-7 128-65 129-7 128 50 129-47v163H0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m0 512 129 19 128-34 129 41 128-45 129 56 128 1 129-29v80H0Z"
  })));
};
export default SvgHeroJobseeker;